const COMMON_FETCH_INGREDIENT_KEYWORDS = {
  START: 'START_COMMON_FETCH_INGREDIENT_KEYWORDS',
  COMPLETE: 'COMPLETE_COMMON_FETCH_INGREDIENT_KEYWORDS',
  FAIL: 'FAIL_COMMON_FETCH_INGREDIENT_KEYWORDS',
  CLEANUP: 'CLEANUP_COMMON_FETCH_INGREDIENT_KEYWORDS',
}

export default COMMON_FETCH_INGREDIENT_KEYWORDS
